import { RSAA } from 'redux-api-middleware';

// Constants
export const PROFILE_SET_EDIT_MODE = 'PROFILE_SET_EDIT_MODE';
export const PROFILE_IS_FETCHING = 'PROFILE_IS_FETCHING';
export const PROFILE_GET_SUCCESS = 'PROFILE_GET_SUCCESS';
export const PROFILE_GET_ERROR = 'PROFILE_GET_ERROR';
export const PROFILE_EDIT_SUCCESS = 'PROFILE_EDIT_SUCCESS';
export const PROFILE_EDIT_ERROR = 'PROFILE_EDIT_ERROR';
export const PROFILE_SET_DEACTIVATE_MODE = 'PROFILE_SET_DEACTIVATE_MODE';
export const PROFILE_DEACTIVATE_USER_SUCCESS = 'PROFILE_DEACTIVATE_USER_SUCCESS';
export const PROFILE_DEACTIVATE_USER_ERROR = 'PROFILE_DEACTIVATE_USER_ERROR';
export const PROFILE_ACTIVATE_USER_SUCCESS = 'PROFILE_ACTIVATE_USER_SUCCESS';
export const PROFILE_ACTIVATE_USER_ERROR = 'PROFILE_ACTIVATE_USER_ERROR';
export const PROFILE_ME_GET_SUCCESS = 'PROFILE_ME_GET_SUCCESS';

// Actions
export const setProfileInEditMode = isEditMode => {
  return {
    type: PROFILE_SET_EDIT_MODE,
    isEditMode
  };
};

/* TOCHECK: Check if the resource is in upper case or lower case */
export const getMyProfile = () => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_ME',
      controlAction: 'self',
      types: [PROFILE_IS_FETCHING, PROFILE_ME_GET_SUCCESS, PROFILE_GET_ERROR]
    }
  };
};

export const getUserProfile = userId => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      param: userId.Id,
      types: [PROFILE_IS_FETCHING, PROFILE_GET_SUCCESS, PROFILE_GET_ERROR]
    }
  };
};

export const editMyProfile = data => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_ME',
      controlAction: 'edit',
      body: data,
      types: [PROFILE_IS_FETCHING, PROFILE_EDIT_SUCCESS, PROFILE_EDIT_ERROR]
    }
  };
};

export const editUserProfile = (data, userId) => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      controlAction: 'edit',
      body: data,
      param: userId,
      types: [PROFILE_IS_FETCHING, PROFILE_EDIT_SUCCESS, PROFILE_EDIT_ERROR]
    }
  };
};

export const setDeactivateMode = mode => {
  return {
    type: PROFILE_SET_DEACTIVATE_MODE,
    mode
  };
};

// TODO: turn it in a async action when we have an API
export const deactivateUser = (data, userId) => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      controlAction: 'edit',
      body: { ...data, status: 'Disabled' },
      param: userId,
      types: [PROFILE_IS_FETCHING, PROFILE_DEACTIVATE_USER_SUCCESS, PROFILE_DEACTIVATE_USER_ERROR]
    }
  };
};

export const activateUser = (data, userId) => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      controlAction: 'edit',
      body: { ...data, status: 'Active' },
      param: userId,
      types: [PROFILE_IS_FETCHING, PROFILE_ACTIVATE_USER_SUCCESS, PROFILE_ACTIVATE_USER_ERROR]
    }
  };
};

/* const checkIsMe = (user, me) => {
    if (
        user &&
        user['@controls'] &&
        user['@controls'].edit &&
        user['@controls'].edit.schema &&
        user['@controls'].edit.schema.properties &&
        user['@controls'].edit.schema.properties.roles
    ) {
        return false;
    }
    return true;
}; */

// Initial State
export const initialState = {
  isFetching: false,
  isEditMode: false,
  isMe: false,
  deactivate: {
    enabled: false,
    confirmed: false
  },
  error: null,
  data: null,
  loggedUser: null,
  activateUserSuccess: null,
  deactivateUserSuccess: null
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_IS_FETCHING:
      return { ...state, isFetching: true, error: null, activateUserSuccess: null, deactivateUserSuccess: null };

    case PROFILE_SET_EDIT_MODE:
      return {
        ...state,
        isEditMode: action.isEditMode,
        deactivate: { ...initialState.deactivate },
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    case PROFILE_ME_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        deactivate: { ...initialState.deactivate },
        error: null,
        /* isMe: checkIsMe(action.payload), */
        data: action.payload,
        loggedUser: action.payload.id,
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    case PROFILE_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        deactivate: { ...initialState.deactivate },
        error: null,
        /* isMe: checkIsMe(action.payload), */
        data: action.payload,
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    case PROFILE_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        data: null,
        deactivate: { ...initialState.deactivate },
        error: action.payload,
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    case PROFILE_EDIT_SUCCESS:
      // TODO: remove ternary if according to API 204 fix
      return {
        ...state,
        isEditMode: false,
        isFetching: false,
        deactivate: { ...initialState.deactivate },
        error: null,
        /* isMe: checkIsMe(action.payload ? action.payload : state.data), */
        data: action.payload ? action.payload : state.data,
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    case PROFILE_EDIT_ERROR:
      return {
        ...state,
        isFetching: false,
        deactivate: { ...initialState.deactivate },
        error: action.payload,
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    case PROFILE_SET_DEACTIVATE_MODE:
      return {
        ...state,
        isEditMode: false,
        deactivate: {
          ...state.deactivate,
          enabled: action.mode,
          confirmed: false
        },
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    case PROFILE_DEACTIVATE_USER_ERROR:
      return {
        ...state,
        isEditMode: false,
        isFetching: false,
        deactivate: {
          confirmed: false
        },
        error: action.payload,
        activateUserSuccess: null,
        deactivateUserSuccess: false
      };

    case PROFILE_ACTIVATE_USER_ERROR:
      return {
        ...state,
        isEditMode: false,
        isFetching: false,
        deactivate: {
          confirmed: false
        },
        error: action.payload,
        activateUserSuccess: false,
        deactivateUserSuccess: null
      };

    case PROFILE_DEACTIVATE_USER_SUCCESS:
      return {
        ...state,
        isEditMode: false,
        isFetching: false,
        deactivate: {
          ...state.deactivate,
          confirmed: true
        },
        error: null,
        data: action.payload ? action.payload : state.data,
        activateUserSuccess: null,
        deactivateUserSuccess: true
      };

    case PROFILE_ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        isEditMode: false,
        isFetching: false,
        deactivate: {
          ...state.deactivate,
          confirmed: true
        },
        error: null,
        data: action.payload ? action.payload : state.data,
        activateUserSuccess: true,
        deactivateUserSuccess: null
      };

    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        isEditMode: false,
        deactivate: { ...initialState.deactivate },
        activateUserSuccess: null,
        deactivateUserSuccess: null
      };

    default:
      return state;
  }
};
